<template>
  <div class="">
    <echart
      chart-id="camera-trap-devs"
      :options="option"
      :not-merge="true"
      :height="160"
    />
  </div>
</template>

<script>
import Echart from '@/components/Chart'
import colors from '@/utlis/colors'
import _ from 'lodash'

export default {
  props: { data: Array, devs: Array, insects: Array, actived: Number },
  components: { Echart },
  computed: {
    option() {
      let { insects, actived } = this
      let series = insects.map(ins => {
        return {
          type: 'bar',
          name: ins.name,
          stack: true,
          label: {
            show: true,
            formatter: ({ data }) => {
              return data > 0 ? data : ''
            }
          },
          data: this.data.map(l => {
            let devs = actived === -1 ? l.devices : [l.devices[actived]]
            let sum = _.sumBy(devs, item => {
              let insect = item.insects.find(ll => ll.id === ins.id)
              return insect ? insect.count : 0
            })
            return [l.day, sum]
          })
        }
      })

      return {
        color: colors,
        legend: {
          left: 52,
          right: '6%',
          bottom: 8,
          type: 'scroll',
          pageButtonPosition: 'end',
          pageIconSize: 16,
          pageTextStyle: { color: '#dcdfe6', fontSize: 14 }
        },
        tooltip: {
          trigger: 'axis',
          confine: false,
          appendToBody: true,
          position: function(point) {
            return [point[0]-120, 0]
          }
        },
        xAxis: { type: 'time', boundaryGap: false },
        yAxis: { show: false, splitLine: { show: false } },
        grid: { top: 32, bottom: 36, left: 20, right: 56 },
        series
      }
    }
  }
}
</script>

<style lang="css" scoped></style>
